import ReactDOMServer from 'react-dom/server';
import { type Asset } from 'types/asset.types';

export const svgToDataUrl = (svgElement: React.ReactElement) => {
  const svgString = new XMLSerializer().serializeToString(
    new DOMParser().parseFromString(
      ReactDOMServer.renderToStaticMarkup(svgElement),
      'image/svg+xml'
    )
  );
  return `data:image/svg+xml;base64,${btoa(svgString)}`;
};

export type CustomCSSProperties = React.CSSProperties & {
  '--circle-color'?: string;
  '--background-color'?: string;
  '--mountain-color'?: string;
};

export const getMakeModel = (asset: Asset) =>
  `${asset?.make?.toLowerCase()}${asset?.model?.toLowerCase()}`;

export const getIsAssetOutOfService = (asset: Asset) => !asset?.isActive;

export const svgStyleImport = (asset: Asset) => {
  const isAssetOffline = getIsAssetOutOfService(asset);
  return {
    '--background-color': isAssetOffline ? '#C3C3C3' : '#0000FF',
    '--mountain-color': isAssetOffline ? '#787878' : '#FFFFFF',
  };
};

export const svgNavPinStyleImport = (loading: boolean) => {
  return {
    '--background-color': loading ? '#1E90FF' : '#FF4D4D',
    '--bottom-color': loading ? '#787878' : '#f9cd2c',
    '--background-color-2': loading ? '#4169E1' : '#FF6B6B',
    '--bottom-color-2': loading ? '#787878' : '#d7b33d',
  };
};

export const svgStyleRedIcon = (asset: Asset) => {
  return {
    '--background-color':
      asset.device.deviceStatus === 'Recently Online'
        ? '#6888d6'
        : asset.device.deviceStatus === 'Offline'
        ? '#F47C02'
        : '#EB5757',
  };
};

export const svgStylePerformanceIcon = (color: string) => {
  return {
    '--background-color': color,
  };
};

export const calculateBoxPosition = (
  clickX: number,
  boxWidth = window.innerWidth * 0.55
) => {
  const screenWidth = window.innerWidth;
  const minMargin = 20;
  const boxHalfWidth = boxWidth / 2;

  // Right edge case
  if (clickX + boxHalfWidth > screenWidth - minMargin) {
    return screenWidth - boxHalfWidth - minMargin;
  }
  // Left edge case
  else if (clickX - boxHalfWidth < minMargin) {
    return boxHalfWidth + minMargin;
  }
  return clickX;
};

export const calculateTailPosition = (
  clickX: number,
  boxWidth = window.innerWidth * 0.35,
  screenWidth = window.innerWidth
) => {
  const minMargin = 20;
  const boxHalfWidth = boxWidth / 2;

  // Calculate position relative to available space
  const relativePosition = (clickX - boxHalfWidth) / (screenWidth - boxWidth);

  if (relativePosition < 0.2) return '20%';
  if (relativePosition > 0.8) return '80%';
  return '50%';
};

export const calculateTopPosition = (clickY: number, displayAbove: boolean) => {
  const screenHeight = window.innerHeight;
  const boxHeight = 280;
  const minMargin = 80;

  if (displayAbove) {
    return Math.max(clickY - boxHeight, minMargin);
  }
  return Math.min(clickY + 30, screenHeight - boxHeight - minMargin);
};
